import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '../uiold';
import { themeColors } from '../uiold/Constants';

import { Market } from '../../types/shared/Market';

type Props = {
  market: Market;
  isSelected: boolean;
  onPress: (marketId: string) => void;
};

function MarketListItem(props: Props) {
  let { market, isSelected, onPress } = props;
  let rootStyle = [styles.root, isSelected && styles.selected];
  return (
    <TouchableOpacity onPress={() => onPress(market.id)} style={rootStyle}>
      <Text type="label" style={styles.marketName}>
        {market.hidden
          ? t('{marketName} (hidden)', { marketName: market.name })
          : market.name}
      </Text>
      <Text type="label">
        {t('Number of Stalls: {numSpots}', { numSpots: market.num_spots })}
      </Text>
      <Text type="label">
        {t('Number of Dates: {numOfDates}', {
          numOfDates: market.dates.length,
        })}
      </Text>
    </TouchableOpacity>
  );
}

let styles = StyleSheet.create({
  root: {
    padding: 15,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: themeColors.lightGrey,
    backgroundColor: themeColors.white,
    cursor: 'pointer',
  },
  selected: {
    borderColor: '#3182ce',
    backgroundColor: 'rgba(5,165,209,.05)',
    borderWidth: 0.5,
  },
  marketName: {
    fontWeight: '600',
  },
});

export default MarketListItem;
